<mydocma-app-pane-header
    [closeVisible]="true"
    text="{{'CO.bp-filter.structure' | translate}}"
    iconName="_stacked-organizational-chart-highlighted-first-node"
    [doneVisible]="false"
    (closeClick)="onCloseClick()">
</mydocma-app-pane-header>

<div style="position: relative; height: 100%;">
    <mydocma-loader class="mydocma-li-loader"
        *ngIf="(isDataLoading$| async)">
    </mydocma-loader>
    <!-- <mydocma-loader class="mydocma-li-loader"
        *ngIf="(isDataLoading$| async) || (liProjectService.isLoading$ | async)">
    </mydocma-loader> -->
    <mydocma-structure-tree
        class="left-pane-structure-tree"
        [treeOptions]="treeOptions"
        [structuresTree]="structuresTree"
        [selectedStructureTreeNode]="selectedStructureTreeNode"
        (structureClick)="onStructureClick($event)"
    >
    </mydocma-structure-tree>
</div>
